var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiagnosis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4058_74154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 2.66669H3.66732C3.3137 2.66669 2.97456 2.80716 2.72451 3.05721C2.47446 3.30726 2.33398 3.6464 2.33398 4.00002V6.33335C2.33398 7.30581 2.72029 8.23845 3.40793 8.92608C4.09556 9.61371 5.02819 10 6.00065 10C6.97311 10 7.90574 9.61371 8.59338 8.92608C9.28101 8.23845 9.66732 7.30581 9.66732 6.33335V4.00002C9.66732 3.6464 9.52684 3.30726 9.27679 3.05721C9.02675 2.80716 8.68761 2.66669 8.33399 2.66669H7.66732",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.66602 10C5.66602 10.5253 5.76948 11.0454 5.9705 11.5307C6.17152 12.016 6.46615 12.457 6.83759 12.8284C7.20902 13.1999 7.64998 13.4945 8.13528 13.6955C8.62058 13.8965 9.14073 14 9.66602 14C10.1913 14 10.7114 13.8965 11.1967 13.6955C11.6821 13.4945 12.123 13.1999 12.4944 12.8284C12.8659 12.457 13.1605 12.016 13.3615 11.5307C13.5626 11.0454 13.666 10.5253 13.666 10V8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 2V3.33333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33398 2V3.33333",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.334 6.66665C12.334 7.02027 12.4745 7.35941 12.7245 7.60945C12.9746 7.8595 13.3137 7.99998 13.6673 7.99998C14.0209 7.99998 14.3601 7.8595 14.6101 7.60945C14.8602 7.35941 15.0007 7.02027 15.0007 6.66665C15.0007 6.31302 14.8602 5.97389 14.6101 5.72384C14.3601 5.47379 14.0209 5.33331 13.6673 5.33331C13.3137 5.33331 12.9746 5.47379 12.7245 5.72384C12.4745 5.97389 12.334 6.31302 12.334 6.66665Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4058_74154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagnosis);
export default __webpack_public_path__ + "static/media/diagnosis.f951229f8b0f2009e4ff3add2f7ff03f.svg";
export { ForwardRef as ReactComponent };